import { Component, Input, OnDestroy, OnChanges, AfterViewInit, ViewChild, SimpleChanges } from '@angular/core';

@Component({
	selector: 'port-access-vlan',
	templateUrl: './port-access-vlan.component.html',
	styleUrls: ['./port-access-vlan.component.scss']
})
export class PortAccessVlanComponent {

	constructor() {

	}

}